export enum EPristupDepozitar {
    ANO = 'ANO',
    NE = 'NE',
    POZDEJI = 'POZDEJI'
}
